import MuiTypography from '@mui/material/Typography';
import { Tooltip } from 'components/atoms/Tooltip';
import { FC, useRef } from 'react';
import { ITypographyProps } from '../type';
import { useOverflowDetection } from 'hooks/common/useOverflowDetection';
import { getEllipsisStyles } from '../style';

export const TypographyWithTooltip: FC<ITypographyProps> = ({
  children,
  maxWidth = '100%',
  sx,
  ellipsis = false,
  tooltipProps,
  ...typographyProps
}) => {
  const textRef = useRef<HTMLDivElement>(null);
  const isOverflowing = useOverflowDetection(textRef);

  return (
    <Tooltip
      title={children}
      placement={tooltipProps?.placement || 'top'}
      disableInteractive={!isOverflowing}
      disableHoverListener={!isOverflowing}
      {...tooltipProps}
    >
      <MuiTypography
        sx={{
          ...(ellipsis && getEllipsisStyles(maxWidth)),
          ...sx,
        }}
        {...typographyProps}
        ref={textRef}
      >
        {children}
      </MuiTypography>
    </Tooltip>
  );
};
